
import type {AxiosResponse} from "axios";
import api from "@/app/services/apiNir.ts";
import type { ApiResponse } from '@/app/types'
import { useNotificationsStore } from '@/app/notify/notifications.ts'
import {Ref, ref} from "vue";

export interface AttachmentFile {
    originalFileName: string
    fileName: string
    contentType: string
    size: number
    uploadedAt:string
    userId:string
    fileId:string
    resource:string
}

export const useFiles = () => {
    const downloading:Ref<boolean> = ref(false);
    const notify =  useNotificationsStore();
    const fetchFile =  async (url:string): Promise<string> => {
        return api.get(url)
            .then((response:AxiosResponse<string>) => {
                return response.data
            })
    }

    const fetchBlob = async (url: string): Promise<Blob> => {
        return api.get(url, { responseType: 'blob' })
            .then((response: AxiosResponse<Blob>) => response.data)
    }

    function download(url:string, fileId:string, filename:string, type:string) {
        let path = `${url}?id=${fileId}`
        downloading.value = true;
        if (type == 'excel') {
            fetchBlob(path).then((blob: Blob) => {
                downloading.value = false;
                downloadExcel(blob, filename)
            })
        } else {
            fetchFile(path).then((response: string) => {
                if (response) {
                    downloading.value = false;
                    if (type == 'pdf')
                        downloadBase64PDF('data:application/pdf;base64,' + response, filename, 'application/pdf');
                }
            })
        }
    }

    function downloadBase64PDF(base64String: string, filename: string, contentType: string) {
        // 1. Convert base64 string to binary data
        const byteCharacters = atob(base64String.split(',')[1] || ""); // Remove data URI prefix if present
        const byteArrays: Uint8Array[] = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });

        // 2. Create a temporary URL for the blob
        const blobUrl = URL.createObjectURL(blob);

        // 3. Create a hidden anchor element for download
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename; // Set filename or default
        link.style.display = 'none'; // Hide the link

        // 4. Append the link to the DOM and trigger the download
        document.body.appendChild(link);
        link.click();

        // 5. Clean up: remove the link and revoke the URL
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
    }

    function downloadExcel(blob: Blob, filename: string) {
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
    }

    return {downloading, fetchFile, download}

}